import { render, staticRenderFns } from "./CompManageDetail.vue?vue&type=template&id=627c1648&"
import script from "./CompManageDetail.vue?vue&type=script&lang=js&"
export * from "./CompManageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports